import React, { Component } from "react";
import { dispatch } from "@rematch/core";
import { Icon, List, Card, Label, Button, Popup, Image, Loader, PlaceholderLine, Message ,Modal} from 'semantic-ui-react';
import EditTextModal from "../../common/EditTextModal";
import ImageResizer from "../ImageResizer/ImageResizer";

import defaultLogo from '../../../images/logo/logo-128.png';
import { toastr } from 'react-redux-toastr';
import { withRouter } from "react-router-dom";
import NothingToShow from "../NothingToShow";
import PlaceHolderSingleLine from "../PlaceHolder/PlaceHolderSingleLine";
import AddCategoryModal from '../../account/settings/Drive/Modal/AddCategoryModal'
import DefaultCategory from './DefaultCategory'
import DeleteCategoryModal from "./DeleteCategory";
import setCategoryImage from '../../../helpers/setCategoryImage'
import { debounce } from "lodash";
import LoadingComponent from "../../common/LoadingComponent";
class CategoryListingCard extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            allCategoryList: null,
            categoryList: null,
            levelDepth: props.levelDepth,
            imgLoader: false,
            isAddCategoryModalOpen: props.isAddCategoryModalOpen,

        }
    }

    async componentWillMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        if(!this.props.allCategoryList){ 
            await dispatch.categories.getAllCategories({ organizationId: this.props.match.params.workspaceId })
        }else{
            this.setState({ allCategoryList: this.props.allCategoryList })
            this.setState({ categoryList: this.props.categoryTreeById })
        }
        this.loadData()
    }

    loadData = debounce(async (id) => {
        if (id) {
            await dispatch.categories.getCategoryById(id)
        } else if (this.props.match.params.categoryId) {
            await dispatch.categories.getCategoryById(this.props.match.params.categoryId)
        } else if (this.props.match.params.baseCategoryId) {
            await dispatch.categories.getCategoryById(this.props.match.params.baseCategoryId)
        }
    }, 50);

    componentWillReceiveProps(newProps) {

        if (this.props.categoryTreeById !== newProps.categoryTreeById) {
            this.setState({ categoryList: newProps.categoryTreeById })
        }
        if (this.props.allCategoryList !== newProps.allCategoryList) {
            this.setState({ allCategoryList: newProps.allCategoryList })
        }

        if (this.props.levelDepth === newProps.levelDepth) {
            dispatch.community.setMainAreaContext(this.props.levelDepth);
        }

        if (this.props.isAddCategoryModalOpen !== newProps.isAddCategoryModalOpen) {
            this.setState({ isAddCategoryModalOpen: newProps.isAddCategoryModalOpen })
        }



    }

    async handleChangeCategory(e, data) {

        if (e) { e.stopPropagation() }

        if (this.props.level === 'platform') {
            this.platformRoute(data)
        }

        if (this.props.level === 'account') {
            await dispatch.categories.getCategoryById(data);
            this.accountRoute(data)
        }

        if (this.props.level === 'workspace') {
            this.workspaceRoute(data)
        }
        await dispatch.account.setSelectedCategoryAsync(data);
    }

    platformRoute = (data) => {
        const history = this.props.history;
        if (this.props.match.params.baseCategoryId) {
            history.push(`/app/platform/settings/public/${this.props.match.params.baseCategoryId}/${data._id}`)
        } else {
            history.push(`/app/platform/settings/public/${data._id}`)
        }
    }

    accountRoute = (data) => {

        const history = this.props.history;
        if (this.props.match.params.baseCategoryId) {
            history.push(`/app/${this.props.match.params.accountId}/settings/knowledgeBank/${this.props.match.params.baseCategoryId}/${data._id}`)
        } else {
            history.push(`/app/${this.props.match.params.accountId}/settings/knowledgeBank/${data._id}`)
        }
    }

    workspaceRoute = (data) => {
        const history = this.props.history;
        if (this.props.match.params.baseCategoryId) {
            history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/categories/${this.props.match.params.baseCategoryId}/${data._id}`)
        } else {
            history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_wsSetting/categories/${data._id}`)
        }
    }

    breadCumbRoute = async (e, path, data) => {
        await dispatch.account.setSelectedCategoryAsync(data);
        const history = this.props.history;
        let url = this.props.location.pathname;
        if (this.props.level === 'platform') {
            url = url.split('/public')[0];
            url = url + "/" + "public"
        }
        if (this.props.level === 'account') {
            url = url.split('/knowledgeBank')[0];
            url = url + "/" + "knowledgeBank"
        }
        if (this.props.level === 'workspace') {
            url = url.split('/_wsSetting')[0];
            url = url + "/" + "_wsSetting/categories"
        }

        if (path === "manage") {
            history.push(url)
        await dispatch.account.setSelectedCategoryAsync("Knowledge Banks");

        }
        if (path === "kb") {
            history.push(url + "/" + data._id)
        }
        if (path === "cat") {
            history.push(url + "/" + this.props.match.params.baseCategoryId + "/" + data._id)
        }

        if (data) {
            this.loadData(data._id);
        } else {
            await dispatch.categories.getAllCategories({ organizationId: this.props.match.params.workspaceId })
        }


    }

    handleCategorySelection = (data) => {

        let setParamId = this.props.match.params && this.props.match.params.subCategoryId ? this.props.match.params.subCategoryId :
            this.props.match.params.categoryId ? this.props.match.params.categoryId :
                this.props.match.params.baseCategoryId ? this.props.match.params.baseCategoryId : null
        if (data.length === 3) {
            let pay = {
                categories: data,
                organizationId: this.props.match.params.workspaceId,
                accountId: this.props.match.params.accountId,
                categoryType: this.props.levelDepth,
                paramId: setParamId
            }
            dispatch.categories.makeDefault(pay)
        }
    }

    setLoader = (setFlag) => {
        this.setState({ imgLoader: setFlag })
    }

    setSelectedCategory = (setData, action) => {
        this.setState({ actionSelectedCategory: setData })
        this.setState({ action: action })
    }





    render() {
        const { envData, level, levelDepth, user, selectedCategory, selectedAccount, catagoryAttachedDetails } = this.props;
        const { baseCategoryId, categoryId, subCategoryId } = this.props.match.params;
        const { categoryList, allCategoryList, isAddCategoryModalOpen, imgLoader, actionSelectedCategory, action } = this.state;



        let kb = allCategoryList && allCategoryList.filter((kb, i) => { return kb._id === baseCategoryId })[0]
        let cat = kb && kb.nodes && kb.nodes.length !== 0 && kb.nodes.filter((ca, i) => { return ca._id === categoryId })[0]

        let CardHeaderBreadCrumb = <div className="categoryListBC">
            <span className="cursor-pointer" onClick={(e) => this.breadCumbRoute(e, 'manage')}>
                Knowledge Banks
            </span>
            {kb ? <React.Fragment> &nbsp;<Icon name="chevron right" />
                <span className="cursor-pointer" onClick={(e) => this.breadCumbRoute(e, 'kb', kb)}>{kb.name}</span>
            </React.Fragment> : null}
            {cat ? <React.Fragment> &nbsp; <Icon name="chevron right" />
                <span className="cursor-pointer" onClick={(e) => this.breadCumbRoute(e, 'cat', cat)}>{cat.name}</span>
            </React.Fragment> : null}
            {subCategoryId ? <React.Fragment> &nbsp; <Icon name="chevron right" />
                <span className="cursor-pointer" onClick={(e) => this.breadCumbRoute(e, 'subCat', subCategoryId)}>{subCategoryId}</span>
            </React.Fragment> : null}  &nbsp;
            {categoryList ? <Label size="mini" > {categoryList.length}</Label> : null}
        </div >

        let NoData = <NothingToShow imgStyle={{ display: "block" }} />
        let CardList = categoryList ?
            categoryList && categoryList.length !== 0 ?
                <List divided verticalAlign='middle' selection={categoryId ? false : true}>
                    {categoryList && categoryList.map((category, index) => {
                        return <List.Item
                            className={`singleLine categoryList padding-b5`}
                            key={index}
                        >
                            <List.Content floated='right'
                                style={{marginTop: "5px"}}
                                className="listViewWithAction"
                            >
                                {( level === "workspace"&& category.default ) || (level === "account" && category.default) ? <Label color='blue' size="mini" className="dIcon" > Default </Label> : null}
                                <Button.Group size='mini' className="mar_Right_5 listViewIcon " >
                                    <ActionIcons
                                        allCategories={categoryList}
                                        accountId={this.props.match.params.accountId}
                                        organizationId={this.props.match.params.workspaceId}
                                        params={this.props.match.params}
                                        organization={this.props.selectedOrganisation}
                                        category={category}
                                        envData={envData}
                                        level={level}
                                        levelDepth={levelDepth}
                                        isAddCategoryModalOpen={isAddCategoryModalOpen}
                                        history={this.props.history}
                                        user={user}
                                        selectedCategory={selectedCategory}
                                        actionSelectedCategory={actionSelectedCategory}
                                        setSelectedCategory={this.setSelectedCategory}
                                        action={action}
                                        imgLoader={imgLoader}
                                        setLoader={this.setLoader}
                                        selectedAccount={selectedAccount} />
                                </Button.Group>
                            </List.Content>
                            <List.Content
                                className="categoryName"
                                onClick={this.props.match.params.categoryId ? null : (e) => this.handleChangeCategory(e, category)}
                            >
                                <List.Header >
                                    <Name
                                        category={category}
                                        level={level}
                                        levelDepth={levelDepth}
                                        params={this.props.match.params}
                                        imgLoader={imgLoader}
                                        actionSelectedCategory={actionSelectedCategory}
                                        selectedAccount={selectedAccount}
                                        action={action}
                                    />

                                </List.Header>
                            </List.Content>
                        </List.Item>
                    })
                    }
                </List > : NoData :
            // <PlaceHolderSingleLine repeat={5} />
            <LoadingComponent active={true}  message="Fetching Knowledge Banks" />

        let AddCategory = isAddCategoryModalOpen ?
            <AddCategoryModal
                isAddCategoryModalOpen={isAddCategoryModalOpen}
                user={this.props.user}
                accountId={selectedAccount._id}
                selectedCategory={this.props.selectedCategory}
                allCategories={categoryList}
                categoryTreeId={this.props.categoryTreeId}
                loading={this.props.addCategoryLoader}
                history={this.props.history}
                level={level}
                levelDepth={levelDepth}
                organization={this.props.selectedOrganisation}
                routeParams={this.props.routeParams}
                organizationId={this.props.match.params.workspaceId}
            //accountId={selectedAccount._id}
            />
            : null

        let DeleteCategory = this.props.isDeleteCategoryModalOpen ?
            <DeleteCategoryModal
                open={this.props.isDeleteCategoryModalOpen}
                catagoryAttachedDetails={catagoryAttachedDetails}
                actionSelectedCategory={actionSelectedCategory}
                action={action}
                selectedAccount={selectedAccount}
                levelDepth={levelDepth}
                level={level}
                accountId={selectedAccount._id}
                organizationId={this.props.match.params.workspaceId}
            />
            : null


        let makeDefault = <Card>
            <Card.Header>
                Default Knowledge Bank
            </Card.Header>
            <Card.Content >
                <DefaultCategory
                    allCategories={allCategoryList}
                    handleCategorySelection={this.handleCategorySelection}
                    pageLevel="workspaceSetting"
                    selectedAccount={selectedAccount}
                />
            </Card.Content>
        </Card>
        return (
            <div className="general-setting">
                {level === "workspace" ? makeDefault : null}
                <Card>
                    <Card.Header>
                        {CardHeaderBreadCrumb}
                    </Card.Header>
                    <Card.Content className="pad_0">
                        {CardList}
                        {AddCategory}
                        {DeleteCategory}
                        <LoadingComponent active={this.props.categoryListLoader}  message="Loading" />
                    </Card.Content>
                </Card>

            </div>
        );
    }
}
export default withRouter(CategoryListingCard);

class Name extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        const { category, level, imgLoader, actionSelectedCategory, selectedAccount, allCategories } = this.props

        let catName = category.name ? <span style={{marginLeft: '10px'}}>{category.name}</span> : <React.Fragment></React.Fragment>

        let catImage = category.isKb ?
            imgLoader && actionSelectedCategory && category && category._id === actionSelectedCategory._id ?
                <Loader style={{ margin: "0px 12px 0 4px" }} inline active={imgLoader} size="tiny" /> :
                <Image src={setCategoryImage(category.image, selectedAccount)} style={{maxWidth: "40px", maxHeight: "29px"}} /> : null



        let subCatCount = category &&
            category.children &&
            category.children.length !== 0 ?
            <Label size="mini" >
                {category.children.length}
            </Label> : category.nodes &&
                category.nodes.length !== 0 ?
                <Label size="mini" >
                    {category.nodes.length}
                </Label> : !category.isSubCategory ? <Label size="mini" >
                    0
                </Label> : null

        return <span>
            {catImage}
            {catName} &nbsp;
            {subCatCount}
        </span>
    }
}

class ActionIcons extends Component {

    constructor(props) {
        super(props)
        this.state = {
            openText: false,
            openImageModal: false,
            updatedImage: props.category && props.category.image
        }
        this.openImageModal = this.openImageModal.bind(this);
        this.openTextModal = this.openTextModal.bind(this);
        this.submitTextModal = this.submitTextModal.bind(this);
        this.updateText = this.updateText.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.category !== newProps.category) {

            this.setState({
                updatedImage: newProps.category && newProps.category.image ?
                    newProps.category.image : newProps.selectedAccount.logo ?
                        newProps.selectedAccount.logo : defaultLogo
            })
        }
    }

    openImageModal(open, e) {
        if (e) { e.stopPropagation() }
        this.setState({ openImageModal: open })
    }

    cloudinaryImage = async (imageData) => {
        this.props.setLoader(true)
        let setParamId = this.props.params && this.props.params.subCategoryId ? this.props.params.subCategoryId :
            this.props.params.categoryId ? this.props.params.categoryId :
                this.props.params.baseCategoryId ? this.props.params.baseCategoryId : null

        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url })
            let updateData = {
                _id: this.state.selectedCategory._id,
                paramId: setParamId,
                image: imageData.data.secure_url,
                categoryType: this.props.levelDepth,
                accountId: this.props.accountId,
                workspaceId:this.props.params.workspaceId
            };
            if (this.props.match && this.props.match.params && this.props.match.params.workspaceId) {
                updateData.organizationId = this.props.match.params.workspaceId
            }
            await dispatch.categories.updateSelectedCategory(updateData);

            this.props.setLoader(false)
        }
    }

    async openTextModal(e, openText, selectedCategory) {
        if (e) { e.stopPropagation() }
        if (openText) {
            try {
                this.setState({
                    openText: openText,
                    newName: selectedCategory.name,
                    updateCategoryError: null
                })
            } catch (error) {
                let message = <div className="confirmMessage">
                    {error.message}
                </div>
                toastr.confirm(message, {
                    onOk: () => { },
                    disableCancel: true
                });
            }
        } else {
            this.setState({
                openText: openText,
                updateCategoryError: null
            })
        }
    }

    updateText(data, name) {

        this.setState({ newName: data.trim() })

        if (name === "Name" && data.toLowerCase() === "others" && this.props.levelDepth === "category") {
            this.setState({
                updateCategoryError: {
                    code: 409,
                    message: 'The word is reserved for Sub category listing !'
                }
            })
        } else {
            let isSameNameExist = false;
            let sameNameCategories = this.props.allCategories.filter((category) => {
                return category.name.trim() === data.trim();
            })
            if (sameNameCategories.length > 0) {
                isSameNameExist = true
            }
            if (isSameNameExist) {
                this.setState({
                    updateCategoryError: {
                        code: 409,
                        message: 'Category with same name already exists.'
                    }
                })
            } else {
                this.setState({
                    updateCategoryError: null
                })
            }
        }

    }

    submitTextModal() {
        this.setState({ openText: false })
        let setParamId = this.props.params && this.props.params.subCategoryId ? this.props.params.subCategoryId :
            this.props.params.categoryId ? this.props.params.categoryId :
                this.props.params.baseCategoryId ? this.props.params.baseCategoryId : null
        let updateData = {
            _id: this.state.selectedCategory._id,
            updatedName: this.state.newName,
            paramId: setParamId,
            categoryType: this.props.levelDepth,
            accountId: this.props.accountId,
            workspaceId:this.props.params.workspaceId
        };

        if (this.props.match && this.props.match.params && this.props.match.params.workspaceId) {
            updateData.organizationId = this.props.match.params.workspaceId
        }
        dispatch.categories.updateSelectedCategory(updateData);
    }

    copyOfBaseCategory = async (e, categoryData) => {
        if (e) { e.stopPropagation() }
        let message = <div className="confirmMessage">
            <h3>Copy Of Knowledge Bank</h3>
            <p>This action will copy all the category and sub category in the knowledge bank?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                let setParamId = this.props.params && this.props.params.subCategoryId ? this.props.params.subCategoryId :
                    this.props.params.categoryId ? this.props.params.categoryId :
                        this.props.params.baseCategoryId ? this.props.params.baseCategoryId : null

                let payload = {
                    _id: categoryData._id,
                    accountId: this.props.accountId ? this.props.accountId : categoryData.accountId,
                    categoryType: this.props.levelDepth,
                    paramId: setParamId,
                    workspaceId:this.props.params.workspaceId
                }
                if (this.props.match && this.props.match.params && this.props.match.params.workspaceId) {
                    payload.organizationId = this.props.match.params.workspaceId
                }

                await dispatch.categories.copyCategory(payload);
            }
        });
    }

    // async deleteCategory(e, data, actionType) {
    //     if (e) { e.stopPropagation() }
    //     try {

    //         data.paramId = this.props.params && this.props.params.subCategoryId ? this.props.params.subCategoryId :
    //             this.props.params.categoryId ? this.props.params.categoryId :
    //                 this.props.params.baseCategoryId ? this.props.params.baseCategoryId : null
    //         await dispatch.account.checkCategoryAttachData(data);
    //     } catch (error) {
    //     }
    // }

    async checkCategoryUsage(e, data, actionType) {
        if (e) { e.stopPropagation() }
        try {

            data.actionType = actionType
            data.organizationId = this.props.params.workspaceId
            data.paramId = this.props.params && this.props.params.subCategoryId ? this.props.params.subCategoryId :
                this.props.params.categoryId ? this.props.params.categoryId :
                    this.props.params.baseCategoryId ? this.props.params.baseCategoryId : null
            await dispatch.categories.categoryAttachData(data);
        } catch (error) {
        }
    }

    hideCategory = async (e, kb) => {
        e.stopPropagation();
        kb.showWorkspace = false;
        dispatch.account.updateCategoryData(kb);
    }
    showCategory = async (e, kb) => {
        e.stopPropagation();
        kb.showWorkspace = true;
        dispatch.account.updateCategoryData(kb);
    }

    makeDefault = async (e, kb, action) => {
        if (e) { e.stopPropagation() }
        let message = action === "Make Default" ? <div className="confirmMessage">
                <h3>Make Default</h3>
                <p>Are you sure you want to make "{kb.name}" the default knowledge bank?</p>
            </div>
            : 
            <div className="confirmMessage">
                <h3>Remove Default</h3>
                <p>Are you sure you want to remove "{kb.name}" from the default list?</p>
            </div>
        toastr.confirm(message, {
            onOk: async () => {
                e.stopPropagation();
                kb.default = !kb.default;
                dispatch.account.updateCategoryData(kb);
            }
        });
    }

    iconClick = (e, categoryData, actions) => {
        this.setState({ selectedCategory: categoryData })
        this.props.setSelectedCategory(categoryData, actions)
        if (actions.name === "Image") {
            this.openImageModal(true, e)
        }

        if (actions.name === "Edit") {
            this.openTextModal(e, true, categoryData)
        }

        if (actions.name === "Duplicate") {
            this.copyOfBaseCategory(e, categoryData)
        }

        if (actions.name === "Delete") {
            this.checkCategoryUsage(e, categoryData, actions.name)
        }

        if (actions.name === "Usage") {
            this.checkCategoryUsage(e, categoryData, actions.name)
        }

        if (actions.name === "Show") {
            this.showCategory(e, categoryData)
        }

        if (actions.name === "Hide") {
            this.hideCategory(e, categoryData)
        }

        if (actions.name === "Make Default" || actions.name === "Remove Default") {
            this.makeDefault(e, categoryData, actions.name)
        }


    }

    render() {
        const { allCategories, category, envData, level, levelDepth, accountId, organization, isAddCategoryModalOpen, history, user, selectedAccount } = this.props;

        //level = ['platform', 'account', 'workspace']
        //levelDepth = ['baseCategory', 'category', 'subcategory']
         let fullControl = organization && organization.fullControl ? false : true;

        let actions = [{
            name: "Image",
            icon: "file image",
            disabled: level === "workspace" && fullControl,
            display: category.isKb && (level === "workspace" || level === "account")
        }, {
            name: "Edit",
            icon: "pencil",
            disabled: level === "workspace" && fullControl,
            display: true
        }, {
            name: "Duplicate",
            icon: "copy",
            disabled: level === "workspace" && fullControl,
            display: true
        },
        {
            name:category && category.default ? "Remove Default" : "Make Default" ,
            icon: "check circle",
            display: level === "account",
            // style: category && category.default ? { color: "blue", opactiy: "1" } : { color: "red", opactiy: "1" }
        }, 
        {
            name: category.showWorkspace ? "Hide" : "Show",
            icon: category.showWorkspace ? "eye slash" : "eye",
            // disabled: fullControl,
            display: category.isKb && level === "account"
        }, {
            name: "Usage",
            icon: "book",
            disabled: false,
            display: category.isKb && level === "workspace",
        }, {
            name: "Delete",
            icon: "trash alternate",
            disabled: (level === "workspace" && fullControl) || category.default,
            display: true
        }]

        let ActionItems = actions && actions.map((i, ind) => {
            return i.display ? <Popup
                key={ind}
                className="popupStyled"
                inverted
                trigger={
                    <Button
                        key={i.name}
                        className="cursor-pointer"
                        icon={i.icon}
                        onClick={(e) => this.iconClick(e, category, i)}
                        disabled={i.disabled}
                        style={i.style}
                    />
                }
                content={i.name}
            /> : null
        })

        let TextModal = this.state.openText ?
            <EditTextModal
                open={this.state.openText}
                openTextModal={this.openTextModal}
                submitTextModal={this.submitTextModal}
                name={this.props.params && this.props.params.subCategoryId ? "Category" :
                    this.props.params.categoryId ? "Sub Category" :
                        this.props.params.baseCategoryId ? "Category" : "Knowledge Bank"}
                headerName="Edit Category"
                text={this.state.newName}
                onChangeText={this.updateText}
                error={this.state.updateCategoryError}
                autoFocus={true}
                {...this.props}
            /> : null

        let ImageModal = this.state.openImageModal ?
            <ImageResizer
                image={this.state.updatedImage}
                openImageModal={this.openImageModal}
                cloudinaryImage={this.cloudinaryImage}
                open={this.state.openImageModal}
                envData={this.props.envData}
                width={180}
                height={108}
            /> : null




        return <React.Fragment>
            {ActionItems}
            {TextModal}
            {ImageModal}
        </React.Fragment>
    }
}